<div class="layout-topbar">
    <div href="#" class="layout-topbar-logo">
        <a class="logo" [routerLink]="['/']">
            Brain Monitor
        </a>
    </div>
    <a class="layout-menu-button" href="#" (click)="app.onMenuButtonClick($event)">
        <i class="pi pi-bars"></i>
    </a>

    <ul class="layout-topbar-menu" role="menu">
        <li #settings class="layout-topbar-item" [ngClass]="{'active-topmenuitem':app.activeTopbarItem === settings}">
            <a href="#" class="layout-topbar-icon first" (click)="app.onTopbarItemClick($event,settings)">
                <i class="topbar-icon pi pi-cog"></i>
            </a>
            <ul class="fadeInDown">
                <li>
                    <a href="#" class="layout-topbar-icon">
                        <i class="topbar-icon pi pi-bookmark"></i>
                    </a>
                    <div class="layout-quickmenu-tooltip">
                        <div class="layout-quickmenu-tooltip-arrow"></div>
                        <div class="layout-quickmenu-tooltip-text">Bookmarks</div>
                    </div>
                </li>
                <li>
                    <a href="#" class="layout-topbar-icon">
                        <i class="topbar-icon pi pi-chart-bar"></i>
                    </a>
                    <div class="layout-quickmenu-tooltip">
                        <div class="layout-quickmenu-tooltip-arrow"></div>
                        <div class="layout-quickmenu-tooltip-text">Statistics</div>
                    </div>
                </li>
                <li>
                    <a href="#" class="layout-topbar-icon">
                        <i class="topbar-icon pi pi-sign-out"></i>
                    </a>
                    <div class="layout-quickmenu-tooltip">
                        <div class="layout-quickmenu-tooltip-arrow"></div>
                        <div class="layout-quickmenu-tooltip-text">Sign Out</div>
                    </div>
                </li>
            </ul>
        </li>
        <li #calendar class="layout-topbar-item" [ngClass]="{'active-topmenuitem':app.activeTopbarItem === calendar}">
            <a href="#" class="layout-topbar-icon first" (click)="app.onTopbarItemClick($event,calendar)">
                <i class="topbar-icon pi pi-calendar"></i>
            </a>
            <ul class="fadeInDown">
                <li>
                    <a href="#" class="layout-topbar-text">
                        SUN
                    </a>
                </li>
                <li>
                    <a href="#" class="layout-topbar-text">
                        MON
                    </a>
                </li>
                <li>
                    <a href="#" class="layout-topbar-text">
                        TUE
                    </a>
                </li>
            </ul>
        </li>
        <li role="menuitem" class="topbar-search layout-topbar-item">
            <a href="#" class="layout-topbar-icon first">
                <i class="topbar-icon pi pi-search"></i>
            </a>
            <input type="text" placeholder="Type to search..." />
        </li>
        <li #profile class="user-profile" role="menuitem" [ngClass]="{'active-topmenuitem':app.activeTopbarItem === profile}">
            <a href="#" (click)="app.onTopbarItemClick($event,profile)">
                <div class="user-profile-info profile-link">
                    <span class="user-profile-name">Username</span>
                    <span class="user-profile-role">Rôle</span>
                </div>
                <img class="logo" src="" />
            </a>
            <ul class="fadeInDown">
                <li class="profile-detail">
                    <div class="user-profile-info">
                        <img class="logo" src="assets/layout/images/avatar/avatar-ava.jpg" alt="prestige-layout" />
                        <div class="profile-info">
                            <span class="user-profile-name">Ava Gregoraci</span>
                            <span class="user-profile-role">Design Ops</span>
                        </div>
                        <a href="#" class="profile-detail-icon" (click)="app.onTopbarSubItemClick($event)">
                            <i class="pi pi-sign-out"></i>
                        </a>
                    </div>
                </li>
                <li>
                    <a href="#" (click)="app.onTopbarSubItemClick($event)">
                        <i class="pi pi-user"></i>
                        <div class="menu-text">
                            <span class="menu-title">Profile</span>
                            <span class="menu-subtitle">Edit your profile</span>
                        </div>

                        <i class="right-icon pi pi-angle-right"></i>
                    </a>
                </li>
                <li>
                    <a href="#" (click)="app.onTopbarSubItemClick($event)">
                        <i class="pi pi-cog"></i>
                        <div class="menu-text">
                            <span class="menu-title">Settings</span>
                            <span class="menu-subtitle">Dashboard Settings</span>
                        </div>
                        <i class="right-icon pi pi-angle-right"></i>
                    </a>
                </li>
                <li>
                    <a href="#" (click)="app.onTopbarSubItemClick($event)">
                        <i class="pi pi-inbox"></i>
                        <div class="menu-text">
                            <span class="menu-title">Messages</span>
                            <span class="menu-subtitle">You have a <div class="blue">3 new</div> messages</span>
                        </div>
                        <i class="right-icon pi pi-angle-right"></i>
                    </a>
                </li>
                <li>
                    <a href="#" (click)="app.onTopbarSubItemClick($event)">
                        <i class="pi pi-globe"></i>
                        <div class="menu-text">
                            <span class="menu-title">Notification</span>
                            <span class="menu-subtitle">No new notification</span>
                        </div>
                        <i class="right-icon pi pi-angle-right"></i>
                    </a>
                </li>
            </ul>
        </li>
    </ul>
</div>
